import React from 'react'
import { Input } from 'antd'
import './style.css'

const CustomInput = React.forwardRef((props, ref) => {
	const { className, type, ...otherProps } = props
	const returnInput = () => {
		switch (type){
			case "password":
				return (
					<Input.Password
						{ ...otherProps }
						ref={ ref }
						className={ `custom-input ${ className ?? "" }` }
					/>
				)
			case "search":
				return (
					<Input.Search
						{ ...otherProps }
						ref={ ref }
						className={ `custom-input ${ className ?? "" }` }
					/>
				)
			case "textarea":
				return (
					<Input.TextArea
						{ ...otherProps }
						ref={ ref }
						className={ `custom-textarea ${ className ?? "" }` }
					/>
				)
			default:
				return (
					<Input
						{ ...otherProps }
						ref={ ref }
						className={ `custom-input ${ className ?? "" }` }
					/>
				)
		}
	}
	return returnInput()
})
export default CustomInput